export function PromptExamplesSkeleton() {
  return (
    <div className="grid animate-pulse gap-4 md:grid-cols-2">
      <div className="h-48 rounded-3xl bg-muted" />
      <div className="h-48 rounded-3xl bg-muted" />
    </div>
  );
}